export default function stringToDate(date: string) {
  const [year, month, day] = date.slice(0, 10).split('-')
  return `${day}.${month}.${year}`
}
